module.exports = __webpack_public_path__ + "static/media/wordmark_white.cf9f1281.svg";